// extracted by mini-css-extract-plugin
module.exports = {"backHome":"BackHome_backHome__a7joM","line":"BackHome_line__2sBmN","icon":"BackHome_icon__1SkRd"};